import { render, staticRenderFns } from "./ModifyRegistrationModal.vue?vue&type=template&id=f50deaa4&"
import script from "./ModifyRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./ModifyRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports